import AjaxManager from "../ajaxManager";

var BookingSummaryService = function () {

    "use strict";

    var self = this;
    this.booking = myApp.bookingService.booking;
    this.peopleSummary;
    this.childrenAgesSummary;
    this.bookContainer = "#book-summary-mobile";
    this.container = '[data-entity="reservation-summary"]';
    this.ajaxManager = new AjaxManager();

    this.updateView = function () {
        if (this.booking.adults != null || this.booking.children != null) {
            this.setPeople();
            this.setChildrenAges();
            myApp.domManager.fillContainer(this.container + ' [data-entity=people]', this.container + ' [data-reservation=people]', this.peopleSummary);
            myApp.domManager.fillContainer(this.container + ' [data-entity=ages]', this.container + ' [data-reservation=ages]', this.childrenAgesSummary);
            myApp.domManager.fillContainer(this.bookContainer + ' [data-entity=people]', this.bookContainer + ' [data-reservation=people]', this.peopleSummary);
        }
        if (this.booking.startDate && this.booking.endDate) {
            this.setDates();
        }
        if (this.booking.rooms.length > 0) {
            $(this.container + ' [data-entity=roomdistribution]').not(this.container + ' [data-entity=roomdistribution]:first').remove();
            this.setRoomDistribution();
        }

        $(this.container + ' [data-entity=activities]').not(this.container + ' [data-entity=activities]:first').remove();
        this.setActivities();
        $(this.container + ' [data-entity=discounts]').not(this.container + ' [data-entity=discounts]:first').remove();
        this.setDiscounts();
        this.setTotalPrice();
    };

    this.setPeople = function () {
        if (this.booking.onlyAdults == 1) {
            this.peopleSummary = this.booking.adults + " " + myApp.translatorService.transchoice('book.info.people', this.booking.adults);
        } else {
            this.peopleSummary = this.booking.adults + " " + myApp.translatorService.transchoice('book.info.adult', this.booking.adults);
            if (this.booking.children > 0) {
                this.peopleSummary += " " + myApp.translator['calendar.prepositions.and'] + " " + this.booking.children + " " + myApp.translatorService.transchoice('book.info.child', this.booking.children);
            }
        }
    };

    this.setChildrenAges = function () {
        this.childrenAgesSummary = "";

        var filteredAges = self.booking.childrenAges.filter(function (age) {
            return age != "";
        });

        if (this.booking.children > 0 && filteredAges.length > 0) {
            for (var i = 1; i <= filteredAges.length; i++) {
                if (i == filteredAges.length && i != 1) {
                    self.childrenAgesSummary += " " + myApp.translator['calendar.prepositions.and'] + " ";
                } else if (i != 1) {
                    self.childrenAgesSummary += ", ";
                }
                self.childrenAgesSummary += filteredAges[i - 1];
            }
            if (filteredAges.length > 1) {
                self.childrenAgesSummary += " " + myApp.translatorService.transchoice('book.info.year', 2);
            } else {
                self.childrenAgesSummary += " " + myApp.translatorService.transchoice('book.info.year', filteredAges[0]);
            }

        }
    };

    this.setDates = function () {
        let start = this.booking.startDate;
        let end = this.booking.endDate;
        $(this.container + ' [data-entity=dates]').show().addClass('dates-filled');
        $(this.container + ' [data-entity=start][data-date=day]').text(('0' + start.getDate()).slice(-2));
        $(this.container + ' [data-entity=start][data-date=month]').text(myApp.translator['calendar.month.' + (start.getMonth() + 1) + '.long']);
        $(this.container + ' [data-entity=start][data-date=weekday]').text(myApp.translator['calendar.week.' + (start.getDay()) + '.long']);
        $(this.container + ' [data-entity=end][data-date=day]').text(('0' + end.getDate()).slice(-2));
        $(this.container + ' [data-entity=end][data-date=month]').text(myApp.translator['calendar.month.' + (end.getMonth() + 1) + '.long']);
        $(this.container + ' [data-entity=end][data-date=weekday]').text(myApp.translator['calendar.week.' + (end.getDay()) + '.long']);

        let startText = myApp.translator['calendar.week.' + (start.getDay()) + '.short'] + ", " + start.getDate() + " " + myApp.translator['calendar.month.' + (start.getMonth() + 1) + '.short'] + " - ";
        let endText = myApp.translator['calendar.week.' + (end.getDay()) + '.short'] + ", " + end.getDate() + " " + myApp.translator['calendar.month.' + (end.getMonth() + 1) + '.short'];

        const buttonSearchDates = document.querySelector('[data-container="button-search-select-dates"]');

        if (buttonSearchDates) {
            buttonSearchDates.classList.remove('vpt-btn-secondary', 'disabled');
            buttonSearchDates.classList.add('vpt-btn-complementary');
        }

        $('#book-summary-mobile [data-entity=dates][data-date=all-date]').text(startText + endText);
        $('#book-summary-mobile [data-date=all-date]').show();

    };

    this.updateTotalPrice = function () {
        var totalPriceElement = $("[data-field=totalprice]");
        var totalPrice = totalPriceElement.data("price");

        totalPriceElement.text(totalPrice + " €");
    };

    this.setRoomDistribution = function () {
        for (var i = 0; i < this.booking.rooms.length; i++) {
            var domRoom = $(this.container + " [data-entity=roomdistribution]:first").clone();
            domRoom.removeClass('hidden')
                .attr('data-room-data-sheet', this.booking.rooms[i]['idRoomDatasheet'])
                .attr('data-room-id', this.booking.rooms[i]['id'])
                .appendTo(this.container + " [data-container=room]");
            domRoom.find('[data-room=name]').text(this.booking.rooms[i]['name']);
            domRoom.find('[data-room=people]').text(this.booking.rooms[i]['people']);

            var infoIcon = domRoom.find('[data-room="info-icon"]');
            if (this.booking.rooms[i]['idRoomDatasheet']) {
                infoIcon.removeClass('d-none');
            } else {
                infoIcon.addClass('d-none');
            }

            let dataRoomPrice = domRoom.find('[data-room=price]');
            if (dataRoomPrice && dataRoomPrice.length > 0) {
                dataRoomPrice.text(this.booking.rooms[i]['price'] + ' €');
            }
        }
        $(this.container + ' [data-container=roomdistribution]').show();
    };

    this.setActivities = function () {

        for (var i = 0; i < this.booking.insurances.length; i++) {
            var domActivity = $(this.container + " [data-entity=activities]:first").clone();
            domActivity.removeClass('hidden').appendTo(this.container + " [data-container=activities]");
            domActivity.find('[data-activity=name]').text(this.booking.insurances[i]['name']);
            domActivity.find('[data-activity=people]').text(this.booking.insurances[i]['people']);
            domActivity.find('[data-activity=price]').text(this.booking.insurances[i]['price'] * this.booking.insurances[i]['people'] + ' €');
            domActivity.find('[data-activity-single-unit=false]').hide();
            if (this.booking.insurances[i]['people'] == 1) {
                domActivity.find('[data-trans-choice=2]').hide();
            } else {
                domActivity.find('[data-trans-choice=1]').hide();
            }
        }

        for (var i = 0; i < this.booking.activities.length; i++) {
            var domActivity = $(this.container + " [data-entity=activities]:first").clone();
            domActivity.removeClass('hidden').appendTo(this.container + " [data-container=activities]");
            domActivity.find('[data-activity=name]').text(this.booking.activities[i]['name']);
            domActivity.find('[data-activity=people]').text(this.booking.activities[i]['people']);
            domActivity.find('[data-activity=price]').text(this.booking.activities[i]['price'] * this.booking.activities[i]['people'] + ' €');

            if (this.booking.activities[i]['singleUnit'] == 1) {
                domActivity.find('[data-activity-single-unit=false]').hide();
            } else {
                domActivity.find('[data-activity-single-unit=true]').hide();
            }

            if (this.booking.activities[i]['people'] == 1) {
                domActivity.find('[data-trans-choice=2]').hide();
            } else {
                domActivity.find('[data-trans-choice=1]').hide();
            }
        }
        if (this.booking.activities.length > 0 || this.booking.insurances.length > 0) {
            $(this.container + ' [data-container=activitiesgroup]').show();
        } else {
            $(this.container + ' [data-container=activitiesgroup]').hide();
        }
    };

    this.setDiscounts = function () {
        for (var i = 0; i < this.booking.userDiscounts.length; i++) {
            var domDiscount = $(this.container + " [data-entity=discounts]:first").clone();
            domDiscount.removeClass('hidden').appendTo(this.container + " [data-container=discounts]");
            domDiscount.find('[data-discount=name]').text(this.booking.userDiscounts[i]['name']);
            domDiscount.find('[data-discount=price]').text(-this.booking.userDiscounts[i]['price'] + ' €');

        }
        if (this.booking.userDiscounts.length > 0) {
            $(this.container + ' [data-container=discountsgroup]').show();
        } else {
            $(this.container + ' [data-container=discountsgroup]').hide();
        }
    };

    this.setTotalPrice = function () {
        var totalPrice = this.booking.getTotalPrice();
        $(this.container + ' [data-field=totalprice]').text(totalPrice + ' €');
        $(this.bookContainer + ' [data-field=totalprice]').text(totalPrice + ' €');
    };

    this.recalculateCancelPolicies = function () {
        var url = myApp.config.routing.recalculateCancelPolicies;
        var complements = this.booking.activities.concat(this.booking.insurances);
        var data = {
            'totalPrice': this.booking.getTotalPrice(),
            'idChollo': $("input[name=id_chollo]").val(),
            'selectedDistribution': $("input[data-selecteddistribution]").attr("data-selecteddistribution"),
            'selectedComplements': JSON.stringify(complements)
        };

        var callback = function (response) {
            $('[data-entity="cancel-policies"]').html(response.cancelPoliciesView);
            myApp.popoverManager.initializePopovers();

            const partialPayment = document.querySelector('[data-entity="partial-payment-price"]');
            const partialPaymentContainer = document.querySelector('[data-entity="partial-payment"]');

            if (!partialPaymentContainer || !partialPayment) {
                return;
            }

            if (response.partialPayment > 0) {
                partialPayment.innerHTML = response.partialPayment + ' €';
                partialPaymentContainer.classList.remove('d-none');
            } else {
                partialPaymentContainer.classList.add('d-none');
            }
        };
        self.ajaxManager.ajaxCall('POST', url, data, callback);
    };

    this.doSearchScroll = function() {
        let lastScrollTop = 0;
        let stickyContainer = $('#book-summary-mobile');
        let topValue = $('[data-entity="mobile-navbar-menu"]').outerHeight(true) + 20;
        document.addEventListener('scroll', function () {
            let scrollTop = myApp.scrollManager.getScrollTop();
            if (scrollTop >= topValue) {
                stickyContainer.addClass('mobile-booking-summary-sticky');
            } else {
                stickyContainer.removeClass('mobile-booking-summary-sticky');
            }
            lastScrollTop = scrollTop;
        });
    };
};

export default BookingSummaryService;
